export default __webpack_public_path__ + "static/media/timeOutlined.bffaf126.svg";